<h3 *ngIf="data.title" mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content>
    <div class="px-3 py-4 d-flex justify-content-center">
        <mat-spinner [color]="'accent'"></mat-spinner>
    </div>
</mat-dialog-content>
